import * as z from 'zod'
import { extraZ, moneyZ, partyZ, pricedTaxZ, selectedExtrasZ } from '../schema'

const dateRange = z.object({
  start: z.string(),
  end: z.string(),
})

export const quoteRequestParamsZ = z.object({
  stayRange: dateRange,
  party: partyZ,
  pitchtypeId: z.string(),
  chargetypeId: z.string().optional(),
  selectedExtras: selectedExtrasZ,
  slug: z.string(),
})
export type QuoteRequestParams = z.infer<typeof quoteRequestParamsZ>

const arrivalTaxZ = z.object({
  amount: moneyZ,
  isHidden: z.boolean(),
  type: z.string(),
})

export type QuoteArrivalTax = z.infer<typeof arrivalTaxZ>

export const quoteZ = z.object({
  arrivalTaxes: arrivalTaxZ.array(),
  balanceDueDate: z.string().nullable(),
  refundUntilDate: z.string().optional(),
  chargetypeId: z.string(),
  commission: z.number(),
  convertedChildren: z.number(),
  deposit: moneyZ,
  extras: extraZ.array(),
  // key is the extra id, and value is the quantity
  extrasInitial: z.record(z.number()),
  pitchesToSell: z.number(),
  priceAccommodation: moneyZ,
  priceTotal: moneyZ,
  remainder: moneyZ,
  paypalEnabled: z.boolean(),
  paymentWhen: z.enum([
    'pitchup_only',
    'stripe',
    'deferred_payment',
    'immediate_payment',
  ]),
  pricedTax: pricedTaxZ.array(),
  convertedParty: z.object({
    adults: z.number(),
    children: z.number(),
    childrenAges: z.number().array(),
    infants: z.number(),
    infantsAges: z.number().array(),
  }),
})
export type Quote = z.infer<typeof quoteZ>

export const quoteRepositoryEndpoint = z
  .function()
  .args(quoteRequestParamsZ)
  .returns(z.promise(quoteZ.nullable()))
